// components/MobileNavigation/IconMapping.tsx
import React from 'react';
import { 
  Building2, 
  Calendar, 
  // FileText, 
  ExternalLink, 
  Shield, 
  Phone,
  Users,
  Globe,
  Award,
  History,
  MapPin,
  Settings,
  // CreditCard,
  // HelpCircle,
  // Mail,
  Database,
  // Zap,
  // UserCheck,
  Star
} from 'lucide-react';

export const getIcon = (itemId: string, label: string) => {
  const iconMap: { [key: string]: React.ReactNode } = {
    // About Us icons
    'values': <Award className="w-4 h-4" />,
    'guiding-principles': <Settings className="w-4 h-4" />,
    'smith-way': <Star className="w-4 h-4" />,
    // 'AO Smith India Journey': <History className="w-4 h-4" />,
    'bangladesh': <MapPin className="w-4 h-4" />,
    'india': <MapPin className="w-4 h-4" />,
    'srilanka': <MapPin className="w-4 h-4" />,
    // 'leadership': <Users className="w-4 h-4" />,
    'brands': <Building2 className="w-4 h-4" />,
    'products': <Database className="w-4 h-4" />,
    'ao-smith-global': <Globe className="w-4 h-4" />,
    
    // Events icons
    'news': <Calendar className="w-4 h-4" />,
    'birthdays': <Calendar className="w-4 h-4" />,
    'work-anniversaries': <Calendar className="w-4 h-4" />,
    'engagement': <Calendar className="w-4 h-4" />,
    
    // Quick Links icons
    // 'advance-tool': <Settings className="w-4 h-4" />,
    // 'ar-tool': <Settings className="w-4 h-4" />,
    // 'alternative-part-code': <Database className="w-4 h-4" />,
    // 'dashboard': <Database className="w-4 h-4" />,
    // 'employee-expense-bgd': <CreditCard className="w-4 h-4" />,
    // 'employee-expense-ind': <CreditCard className="w-4 h-4" />,
    // 'employee-expense-lka': <CreditCard className="w-4 h-4" />,
    // 'employee-discounts': <CreditCard className="w-4 h-4" />,
    // 'hrms': <UserCheck className="w-4 h-4" />,
    // 'it-helpdesk': <HelpCircle className="w-4 h-4" />,
    // 'invoice-cancellation': <FileText className="w-4 h-4" />,
    // 'jv-entry': <FileText className="w-4 h-4" />,
    // 'legatrix': <Shield className="w-4 h-4" />,
    // 'sap-successfactors': <Database className="w-4 h-4" />,
    // 'sales-portal': <Building2 className="w-4 h-4" />,
    // 'srn-pod': <FileText className="w-4 h-4" />,
    // 'ff-workflow': <Zap className="w-4 h-4" />,
    // 'web-email': <Mail className="w-4 h-4" />,
    // 'workflow-automation': <Zap className="w-4 h-4" />,
    
    // Ethics & Compliance icons
    'speakup-line': <Phone className="w-4 h-4" />,
    'toolkits': <Settings className="w-4 h-4" />,
    
    // Contact icons
    'bangalore': <MapPin className="w-4 h-4" />,
    'mumbai': <MapPin className="w-4 h-4" />,
    'dhaka': <MapPin className="w-4 h-4" />,
    'colombo': <MapPin className="w-4 h-4" />
  };

  return iconMap[itemId] || <ExternalLink className="w-4 h-4" />;
};

export const getMainNavIcon = (itemId: string) => {
  const mainIconMap: { [key: string]: React.ReactNode } = {
    'about': <Building2 className="w-5 h-5" />,
    'events': <Calendar className="w-5 h-5" />,
    // 'quick-links': <Database className="w-5 h-5" />,
    'ethics-compliance': <Shield className="w-5 h-5" />,
    'contact': <Phone className="w-5 h-5" />
  };
  return mainIconMap[itemId] || <ExternalLink className="w-5 h-5" />;
};